// src/hooks/vehicle/useGetPrivateVehicleById.ts

import { useState, useEffect } from 'react';
import { VehicleData } from '../../types/vehicle';
import { api } from '../../services/api';

const useGetPrivateVehicleById = (vehicleId: string | undefined) => {
  const [data, setData] = useState<VehicleData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!vehicleId) return;

    setIsLoading(true);
    setIsError(false);

    api
      .get(`/v1/api/vehicles/${vehicleId}`)
      .then(response => {
        setData(response.data);
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [vehicleId]);

  return { data, isLoading, isError };
};

export default useGetPrivateVehicleById;

